/** Converts a base64 string to a Blob object.
 * This function originally came from the following stackoverflow post:
 * https://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
 */
export function b64toBlob(
  b64Data: string,
  contentType: string = "",
  sliceSize = 512
) {
  const byteCharacters = atob(b64Data);
  const byteArrays: Array<Uint8Array<ArrayBuffer>> = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array<number>(slice.length);

    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    byteArrays.push(new Uint8Array(byteNumbers));
  }

  return new Blob(byteArrays, { type: contentType });
}
